var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{class:_vm.className,attrs:{"blank":"","width":_vm.size,"height":_vm.size,"rounded":"circle","blank-color":_vm.hex,"alt":_vm.title,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }